import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 style={{
      "fontSize": "1.875rem"
    }}>Live Projects <a style={{
        "fontSize": "1rem"
      }} href="https://github.com/barasec" target="_blank">(GitHub)</a></h3>
    <br />
    <ProjectCard title='Free-Security.org' link='https://free-security.org/' bg='linear-gradient(to right, #D4145A 0%, #FBB03B 100%)' mdxType="ProjectCard">
  Application Security Platform & Free Online Pentesting Tools. Built with AWS, Nginx, ReactJS, NodeJS, Express, & MongoDB
    </ProjectCard>
    <ProjectCard title='Bara Shop' link='https://barashop.herokuapp.com' bg='linear-gradient(to left, #D4145A 0%, #FBB03B 100%)' mdxType="ProjectCard">
  A MERN & Redux eCommerce Platform. Full featured shopping cart, admin
  management, and PayPal / credit card integration
    </ProjectCard>
    <ProjectCard title='Simply Food Recipes' link='https://simplyyrecipes.netlify.app' bg='linear-gradient(to right, rgb(102, 45, 140) 0%, rgb(237, 30, 121) 100%)' mdxType="ProjectCard">
  No Fluff, Just Recipes. Created with GatsbyJS, ReactJS, & Contentful Headless CMS
    </ProjectCard>
    <ProjectCard title='A List for Everyone' link='https://todolist-4-everyone.herokuapp.com/' bg='linear-gradient(to right, rgb(0, 146, 69) 0%, rgb(252, 238, 33) 100%)' mdxType="ProjectCard">
  Easy, unlimited, & shareable ToDo lists for everyone! Created with NodeJS, Express, EJS, MongoDB Atlas, & Mongoose
    </ProjectCard>
    <ProjectCard title='Daily Journal' link='https://dailyjournal0.herokuapp.com/' bg='linear-gradient(to right, rgb(213, 133, 255) 0%, rgb(0, 255, 238) 100%)' mdxType="ProjectCard">
  Write your daily thoughts without any troubles here! Made possible with NodeJS, Express, EJS, MongoDB Atlas, Mongoose
    </ProjectCard>
    <ProjectCard title='And Many More!' link='https://github.com/barasec' bg='linear-gradient(to bottom, #30cfd0 0%, #330867 100%)' mdxType="ProjectCard">
   This Portfolio (GatsbyJS, ReactJS), and many more projects in Java, Javascript, Python, PHP, Google Flutter (Dart), C, and Bash are available on my <strong><a href="https://github.com/barasec" target="_blank">GitHub</a></strong>;
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      